import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FadeOutAnimation} from '@helpers/animations/fadeInOut.animation';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {SpecialistService} from '../../services/specialist.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-download-button',
    templateUrl: './download-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./download-button.component.scss'],
    animations: [
        FadeOutAnimation,
    ]
})
export class DownloadButtonComponent implements OnInit {

    @Input() specialistIds: number[] = [];

    permissions = UserNamespace.Permission;

    constructor(
        private specialistApi: SpecialistService,
        private ajaxDownloadService: AjaxDownloadService
    ) {
    }

    ngOnInit() {
    }

    generateSpecialistListDocument(withDocuments = false) {
        this.ajaxDownloadService.do({
            url: this.specialistApi.generateListDocumentUrl,
            taskName: 'Список специалистов' + (withDocuments ? ' с копиями' : ''),
            method: 'post',
            data: {
                ids: this.specialistIds,
                format: withDocuments ? 2 : 1
            }
        });
    }
}
